module.exports = __webpack_public_path__ + "static/media/icon.dcf1663c.png";